export const notificationsConstants = {
    GETNOTIFICATIONS_REQUEST: "GETNOTIFICATIONS_REQUEST",
    GETNOTIFICATIONS_SUCCESS: "GETNOTIFICATIONS_SUCCESS",
    GETNOTIFICATIONS_FAILURE: "GETNOTIFICATIONS_FAILURE",
    GETNOTIFICATIONS_SHOW: "GETNOTIFICATIONS_SHOW",
  };
  